import flatpickr from "flatpickr";

document.addEventListener("DOMContentLoaded", function() {
    let targetInput = "#job_start_date";

    flatpickr(targetInput, {enableTime: true});
});